<template>
  <Card class="days-card" :class="classesCard" background="none">
    <div class="days-card__header">
      <div class="days-card__header-left">
        <span>{{ typeTranslate[item.type] }}</span>
        <h3>{{ item.content }}</h3>
      </div>
      <div class="days-card__header-right">
        <svg-icon v-if="isCompleted" name="like" class="days-card__header-success" />
        <svg-icon :name="`tasks/${item.type}`" />
      </div>
    </div>
    <div class="days-card__body">Задание {{ item.number }}</div>
    <div class="days-card__footer" :class="{ 'days-card__footer--lock': isLock }">
      <div>
        <button>
          <svg-icon name="play" />
          Начать
        </button>
        <svg-icon v-if="isLock" name="lock" />
      </div>
      <span>{{ item.points }} {{ item.points | pluralize('очко', 'очка', 'очков') }}</span>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/Common/Card'

export default {
  name: 'DaysCard',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    classesCard() {
      return [`days-card--${this.item.type}`, `days-card--${this.item.status}`]
    },

    isCompleted() {
      return this.item.status === 2
    },

    isLock() {
      return this.item.status === 0
    },

    typeTranslate() {
      return {
        letters: 'Тренажёр',
        material: 'Образовательный материал',
        content: 'Контент',
        test: 'Тест'
      }
    }
  },

  components: {
    Card
  }
}
</script>

<style scoped lang="scss">
.days-card {
  transition: 0.3s;
  background-repeat: no-repeat;
  background-color: $white;
  background-position: right;

  &:hover {
    box-shadow: 0 4px 20px rgba($mine-shaft, 0.25);
    transform: translateY(-1px);
  }

  &--letters {
    background-image: url('/img/letters-background.svg?v=3');
  }

  &--content {
    background-image: url('/img/content-background.svg?v=3');
  }

  &--test {
    background-image: url('/img/test-background.svg?v=3');
  }

  &--material {
    background-image: url('/img/material-background.svg?v=12');
  }

  &--0 &__header-right svg::v-deep {
    .background {
      fill: $whisper;

      &-stroke {
        stroke: $whisper;
      }
    }

    .content {
      fill: $french-gray;

      &-stroke {
        stroke: $french-gray;
      }
    }
  }

  &--1 &__header-right svg::v-deep {
    box-shadow: 0 4px 16px rgba($luchmara, 0.4);

    .background {
      fill: $luchmara;

      &-stroke {
        stroke: $luchmara;
      }
    }

    .content {
      fill: $whisper;

      &-stroke {
        stroke: $whisper;
      }
    }
  }

  &--2 &__header-right svg:last-of-type::v-deep {
    box-shadow: 0 4px 16px rgba($cream-can, 0.4);

    .background {
      fill: $cream-can;

      &-stroke {
        stroke: $cream-can;
      }
    }

    .content {
      fill: $whisper;

      &-stroke {
        stroke: $whisper;
      }
    }
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;

    &-left {
      span {
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
        letter-spacing: 0.1px;
        color: $manatee;
      }

      h3 {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
        color: $deepdark;
        margin-top: 8px;

        @include md-and-down {
          font-size: 15px;
        }
      }
    }

    &-right {
      display: flex;
      align-items: flex-start;

      svg:last-of-type::v-deep {
        width: 56px;
        height: 56px;
        border-radius: 16px;
      }
    }

    &-success {
      width: 32px;
      height: 32px;
      background: $cream-can;
      box-shadow: 0 4px 16px rgba($cream-can, 0.4);
      border-radius: 12px;
      stroke: $whisper;
      margin-right: 8px;
    }
  }

  &__body {
    font-weight: 500;
    font-size: 15px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: $manatee;
    margin: 16px 0 40px;

    @include md-and-down {
      margin: 24px 0 32px;
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      font-weight: 500;
      font-size: 24px;
      color: $luchmara;

      @include md-and-down {
        font-size: 20px;
      }
    }

    &--lock {
      span {
        color: $manatee !important;
      }

      button {
        pointer-events: none;

        svg {
          fill: $manatee !important;
        }
      }
    }

    & > div {
      display: flex;
      align-items: center;

      button {
        background: $whisper;
        width: 110px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 12px;
        font-weight: 500;
        font-size: 18px;
        letter-spacing: 0.2px;
        color: rgba($deepdark, 0.5);

        svg {
          width: 14px;
          margin-right: 10px;
          fill: $luchmara;
        }
      }

      svg {
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        background: $whisper;
        border-radius: 12px;
        fill: $manatee;
        margin-left: 8px;
      }
    }
  }
}
</style>
